export const caseFieldsCls = 'tcm-case-fields-page';

export const caseFormsCls = 'tcm-case-forms-page';

export const tbaCls = 'tcm-tba-page';

export const ebaCls = 'tcm-eba-page';

export const slaCls = 'tcm-sla-page';

export const webformsCls = 'tcm-webforms-page';

// multi-tab page panel
export const navigationPanelCls = 'tcm-navigation-panel';

// case list page
export const viewsPagesCls = 'tcm-views-pages';

// case processing page
export const processingPageCls = 'tcm-case-processing-page';
